import { InjectionToken } from '@angular/core';
import { AbTestOptions } from '../domain/models/ab-test-options.model';

export const RMA_AB_TEST_CONFIG = new InjectionToken<AbTestOptions[]>('RMA_AB_TEST_CONFIG');
